import { type WorkerMissingLicenseBookabilityUnmetCriteriaStatus } from "@src/appV2/OpenShifts/ShiftAction/types";
import { Pill, type PillSize, type PillVariant } from "@src/appV2/redesign/system/ui-components";

interface LicensePillProps {
  status: WorkerMissingLicenseBookabilityUnmetCriteriaStatus;
  size?: PillSize;
  variant?: PillVariant;
  /**
   * If true, the pill will be compact and show a shorter label
   */
  compact?: boolean;
}

function getLabel(status: WorkerMissingLicenseBookabilityUnmetCriteriaStatus, isCompact: boolean) {
  if (isCompact) {
    return "License";
  }

  if (status === "pending") {
    return "License in review";
  }

  return "License missing";
}

export function LicensePill(props: LicensePillProps) {
  const { status, size = "small", variant = "outlined", compact = false } = props;

  return (
    <Pill
      size={size}
      variant={variant}
      label={getLabel(status, compact)}
      iconType="locked-filled"
      backgroundColor={(theme) => theme.palette.background.tertiary}
      outlineColor={(theme) => theme.palette.intent?.neutral.border}
      color={(theme) => theme.palette.intent?.neutral.text}
      iconColor={(theme) => theme.palette.intent?.neutral.icon}
      sx={{
        width: "fit-content",
      }}
    />
  );
}
